export default {
    errorLog_00001: 'Select station',
    errorLog_00002: 'Select model',
    errorLog_00003: 'start time',
    errorLog_00004: 'end time',
    errorLog_00005: 'to',
    errorLog_00006: 'Enter SN',
    errorLog_00007: 'Time',
    errorLog_00008: 'Log classification',
    errorLog_00009: 'All',
    errorLog_00010: 'Severe Error',
    errorLog_00011: 'Abnormal',
    errorLog_00012: 'Offline',
    errorLog_00013: 'Enter error code',
    errorLog_00014: 'Description',
    errorLog_00015: 'Error code',
    errorLog_00016: 'More info',
    errorLog_00017: 'Station',
    errorLog_00018: 'Type',
    errorLog_00019: 'Restored time',
    errorLog_00020: 'Recovered',
    errorLog_00021: 'Not recovered',
    errorLog_00022: 'Please select the time',
}
